var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("Page not found")]),_c('div',[_c('router-link',{attrs:{"to":{name: 'overview'}}},[_vm._v("Return to dashboard")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }